import { Pipe, PipeTransform } from '@angular/core';
import { AnnouncementStatus } from '../../../../shared/enums/announcement-status.enum';

@Pipe({
  name: 'announcementStatusBadgeClass',
  standalone: true,
})
export class AnnouncementStatusBadgeClassPipe implements PipeTransform {
  transform(status: AnnouncementStatus | null | undefined): string {
    switch (status) {
      case AnnouncementStatus.ROBOCZY:
        return 'status-badge status-draft';
      case AnnouncementStatus.OPUBLIKOWANY:
        return 'status-badge status-published';
      case AnnouncementStatus.BLAD:
        return 'status-badge status-error';
      case AnnouncementStatus.ARCHIWALNY:
        return 'status-badge status-archived';
      default:
        return 'status-badge';
    }
  }
}
